(() => {
  if (window.waxerCartPageLayoutReady) return;
  window.waxerCartPageLayoutReady = true;
  const form = document.querySelector('.template-cart #cart');
  const hint = document.querySelector('[data-cart-scroll-hint]');
  if (!form || !hint) return;
  const update = () => {
    const hidden = form.scrollHeight <= form.clientHeight + 2;
    if (hint.hidden !== hidden) hint.hidden = hidden;
  };
  new ResizeObserver(update).observe(form);
  new MutationObserver(update).observe(form, {childList:true,subtree:true});
  window.addEventListener('resize', update, {passive:true});
  update();
})();
